export const getFormFields = () => {
  return {
    defaultError: '',
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    referral: '',
    ssn: '',
    birthDate: '',
    line1: '',
    line2: '',
    postalCode: '',
    city: '',
    state: '',
    segment: '',
    checkbox: '',
    businessName: '',
    registeredState: '',
    ein: '',
    ownershipPercent: ''
  }
}



// WEBPACK FOOTER //
// ./src/services/entities/errorService.js